<template>
  <div id="add-form">
    <div class="title-bar">
      <a-icon type="arrow-left" @click="goBack" />
      <h1>Edit Form Mapping</h1>
    </div>
    <a-form v-if="!loading">
      <a-form-item label="Webhook Name" :label-col="{ span: 5 }" :wrapperCol="{ span: 13 }">
        <h3>
          {{ data.WebhookName }}
          <span class="form-id">{{data.WebhookId}}</span>
        </h3>
      </a-form-item>
      <a-form-item label="Webhook URL" :label-col="{ span: 5 }" :wrapperCol="{ span: 13 }">
        <h3 v-if="platform == 'snapchat'">{{ (`${apiUrl}/wh-snap/${data.WebhookId}`) }}</h3>
        <h3 v-else>{{ (`${apiUrl}/wh/${data.WebhookId}`) }}</h3>
      </a-form-item>
      <a-form-item label="Webhook Key" :label-col="{ span: 5 }" :wrapperCol="{ span: 13 }">
        <h3>{{ data.WebhookKey }}</h3>
      </a-form-item>
      <a-form-item>
        <field-mappings :checking-form="savingForm" :is-production="isProduction"></field-mappings>
      </a-form-item>
      <a-form-item class="center-buttons" :wrapper-col="{ offset: 5, span: 13 }">
        <a-button
          :disabled="canSave"
          :loading="savingForm"
          class="create-button"
          type="primary"
          @click="submitMappings()"
        >
          {{
          savingForm ? "Saving" : "Update Form Mapping"
          }}
        </a-button>
      </a-form-item>
    </a-form>
    <a-spin size="large" v-if="loading"></a-spin>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import FieldMappings from "@/components/FieldMappings";

export default {
  components: {
    FieldMappings
  },
  computed: {
    ...mapState([
      "user",
      "apiUrl",
      "jsonData",
      "isProduction",
      "isErrorJsonData"
    ]),
    canSave() {
      return this.isErrorJsonData;
    }
  },
  data() {
    return {
      loading: true,
      savingForm: false,
      data: null,
      platform: this.$route.query.platform || 'google'
    };
  },
  methods: {
    submitMappings() {
      if (this.postUrl == "") {
        alert("Please fill out the Post URL field.");
        return {};
      }
      if (this.isErrorJsonData || JSON.stringify(this.jsonData) == "") {
        alert("Invalid JSON value");
        return {};
      }
      this.saveForm();
    },
    saveForm() {
      this.savingForm = true;
      const hideLoading = this.$message.loading("Saving");
      axios({
        method: "post",
        url: `${this.apiUrl}/manage-webhook`,
        headers: {
          Authorization: this.user.signInUserSession.idToken.jwtToken
        },
        params: {
          action: "ACTIVATE_WEBHOOK",
          id: this.data.WebhookId,
          platform: this.platform
        },
        data: {
          name: this.data.WebhookName,
          jsonData: this.jsonData,
          isProduction: this.isProduction
        }
      }).then(
        rslt => {
          hideLoading();
          if (rslt.data.status == "ok") {
            this.$router.go(-1);
            alert("Mapping successfully updated.");
          } else {
            alert(
              "There was a problem saving the mapping: " + rslt.data.message
            );
          }
          this.savingForm = false;
        },
        err => {
          console.log(err);
          hideLoading();
          alert("Unable to save the mapping. Server responded with: " + err);
          this.savingForm = false;
        }
      );
    },
    goBack() {
      this.$router.back();
    }
  },
  mounted() {
    // load up the form data from the database. I suppose we could do this in
    // the store instead.
    axios({
      method: "get",
      url: `${this.apiUrl}/manage-webhook`,
      headers: {
        Authorization: this.user.signInUserSession.idToken.jwtToken
      },
      params: {
        action: "GET_WEBHOOK",
        id: this.webhookId,
        platform: this.platform
      }
    })
      .then(rslt => {
        this.data = rslt.data.data;
        this.$store.commit("setFormData", {
          jsonData: this.data.JsonData,
          isProduction: this.data.IsProduction,
          isError: false
        });
        this.loading = false;
      })
      .catch(err => {
        alert("Unable to load webhook");
        this.loading = false;
      });
  },
  props: ["webhookId"]
};
</script>

<style lang="scss" scoped>
#add-form {
  display: flex;
  flex-direction: column;
}
.create-button {
  margin-right: 10px;
}
</style>
<style>
.center-buttons .ant-form-item-control {
  text-align: center;
}
.form-id {
  color: #999;
  margin-left: 15px;
}
</style>
